











































import { defineComponent } from "@vue/composition-api"

import SiteHeader from "@/components/SiteHeader.vue"
import SiteFooter from "@/components/SiteFooter.vue"
import SystemNotifications from "@/components/SystemNotifications.vue"
import TopCarousel from "@/components/TopCarousel.vue"
import ChatBot from "@/components/ChatBot.vue"

import { getAvailableLocales, momentInstance } from "@/plugins/i18n"

// sp判定
import isMobile from "ismobilejs"

export default defineComponent({
  components: { SiteHeader, SiteFooter, SystemNotifications, TopCarousel, ChatBot },
  setup: () => {
    return {
      locales: getAvailableLocales(),
      isMobile,
    }
  },
  mounted: () => {
    // insert DigiCert Seal
    const siteSealContainerId = "digicert-seal-container"
    const siteSealNode = document.createElement("script")
    siteSealNode.setAttribute("async", "")
    siteSealNode.setAttribute("src", "https://seal.digicert.com/seals/cascade/seal.min.js")
    const containerNode = document.getElementById(siteSealContainerId)
    if (containerNode) {
      containerNode.appendChild(siteSealNode)
    } else {
      console.debug(`DigiCert site seal container "${siteSealContainerId}" is not found.`)
    }
  },
  methods: {
    // @ts-ignore
    onSelectLocale: (nextLocale: string) => momentInstance.locale(nextLocale),
  },
})
